import React from "react";
import { Link } from "react-router-dom";
import { Dialog, Title2, Body2, Button } from "@activecollab/components";
import PropTypes from "prop-types";
import { TrophyIcon } from "~/components/svg";

const CompletingProcessSuccessDialog = ({ open, title, content, buttonText, linkTo, reloadOnAction }) => {
  return (
    <Dialog
      open={open}
      className="tw-items-center tw-rounded-[20px] tw-px-5"
      disableCloseOnEsc
    >
      <TrophyIcon
        width={118}
        height={148}
        className="tw-mt-20 tw-fill-theme-900"
      />
      <Title2
        align="center"
        className="tw-mt-5"
      >
        {title ? title : "You have successfully activated ActiveCollab plan!"}
      </Title2>
      <Body2
        className="tw-mt-2"
        color="tertiary"
      >
        {content ? content : "Explore the ActiveCollab features and organize your work."}
      </Body2>
      <Link
        to={"/" + linkTo}
        reloadDocument={reloadOnAction}
      >
        <Button
          className="tw-mt-8 tw-mb-10"
          size="big"
        >
          {buttonText ? buttonText : "Get started!"}
        </Button>
      </Link>
    </Dialog>
  );
};

CompletingProcessSuccessDialog.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  content: PropTypes.string,
  buttonText: PropTypes.string,
  linkTo: PropTypes.string,
  reloadOnAction: PropTypes.bool,
};

CompletingProcessSuccessDialog.defaultProps = {
  open: false,
  reloadOnAction: false,
  linkTo: "projects",
};

export default CompletingProcessSuccessDialog;
